import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { register as registerSwiperElements } from 'swiper/element/bundle';
registerSwiperElements();

// Clear navigation flag on app startup to ensure proper refresh detection
sessionStorage.removeItem('app_navigation_flag');

bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err));
